/**
 * Kernel Enums — shared across all bounded contexts
 */

export enum UserRole {
  STUDENT = 'STUDENT',
  TEACHER = 'TEACHER',
  ADMIN = 'ADMIN',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  VERIFIED = 'VERIFIED',
  SUSPENDED = 'SUSPENDED',
}

export enum VerificationStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  REFUNDED = 'REFUNDED',
  FAILED = 'FAILED',
}

export enum NotificationType {
  COURSE_ENROLLMENT = 'COURSE_ENROLLMENT',
  COURSE_REMINDER = 'COURSE_REMINDER',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  PAYMENT_PROCESSED = 'PAYMENT_PROCESSED',
  DOCUMENT_VERIFIED = 'DOCUMENT_VERIFIED',
  SYSTEM_ANNOUNCEMENT = 'SYSTEM_ANNOUNCEMENT',
}

export enum MessageType {
  TEXT = 'TEXT',
  FILE = 'FILE',
  SYSTEM = 'SYSTEM',
}

export enum DocumentType {
  ID_VERIFICATION = 'ID_VERIFICATION',
  EDUCATION_CERTIFICATE = 'EDUCATION_CERTIFICATE',
  TEACHING_CERTIFICATE = 'TEACHING_CERTIFICATE',
  BACKGROUND_CHECK = 'BACKGROUND_CHECK',
}

export enum MaterialType {
  PDF = 'PDF',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  LINK = 'LINK',
}
